import { FiChevronDown } from "react-icons/fi";
import { FaGlobe, FaShoppingCart } from "react-icons/fa";

export default function Header() {
  return (
    <header className="w-full bg-white">
      <div className="mx-auto max-w-screen-2xl px-1.5 lg:px-16">
        <div className="flex h-20 items-center justify-between border-y border-gray-200 px-3 lg:h-16 lg:border-0 lg:px-0">
          <a
            href="/"
            aria-label="Homepage"
            className="flex shrink-0 items-center"
          >
            <img
              src="/logo.png"
              alt="PETRONAS Twin Towers Sky Xperience"
              className="h-12 w-40 object-contain"
            />
          </a>

          <nav
            aria-label="Header navigation"
            className="flex shrink-0 items-center gap-4 text-neutral-700 sm:gap-8 lg:text-gray-900"
          >
            <button
              type="button"
              aria-label="Select currency"
              className="flex items-center gap-1 text-base font-bold leading-none lg:font-semibold"
            >
              <span>MYR</span>
              <FiChevronDown
                aria-hidden="true"
                className="h-5 w-5 stroke-3"
              />
            </button>

            <button
              type="button"
              aria-label="Select language"
              className="flex items-center gap-1 text-base font-bold leading-none lg:font-semibold"
            >
              <span>EN</span>
              <FaGlobe aria-hidden="true" className="h-4 w-4" />
            </button>

            <a
              href="/cart"
              aria-label="Shopping cart"
              className="flex items-center justify-center"
            >
              <FaShoppingCart aria-hidden="true" className="h-5 w-5" />
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}